// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606090016/js/" + chunkId + "." + {"44":"d5c412d3","225":"ca94019c","481":"b40fd4d2","486":"7177d85a","770":"c4d294cc"}[chunkId] + ".0.40440341800103363.chunk.js";
};